const hasTouchedGlobals = (children) => {
  if (!children) {
    return false;
  }

  return children.some((child) => child.touched && child.hasEnabledGlobals);
};

export default hasTouchedGlobals;
